export default {
  inserted: el => {
    function loadImage() {
      const imageContainer = el.querySelector('.image-wrapper')
      if (imageContainer) {
        imageContainer.addEventListener("error", () => console.log("error"));
        imageContainer.style.background = "url('" + imageContainer.dataset.url +"') center center/cover no-repeat";
      }
    }

    function handleIntersect(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    function createObserver() {
      const options = {
        root: null,
        threshold: "0"
      };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    }
    if (window["IntersectionObserver"]) {
      createObserver();
    } else {
      loadImage();

    }
  }
};
